import "./style.css";
import CVContainer from "../common/CVContainer/CVContainer";
import { CALLBACK } from "../../constants/constants";

const Callback = () => {
  return <CVContainer type={CALLBACK} />;
};

export default Callback;
